<template>
  <nav>
    <div class="window">
      <div class="header">
        <div class="burger-container">
          <div class="title-container">
            <div class="burger-wrapper">
              <div id="burger" @click="handleOpenMenu">
                <div class="bar topBar"></div>
                <div class="bar btmBar"></div>
              </div>
            </div>
            <div id="header-title">
              <router-link to="/">
                <div style="display: flex; align-items:center;">
                  <img :src="getImage('logo.jpg')" alt="Mirka Tech" />
                  <span style="width: 24px;"/>
                  <h1 style="font-family: englishfont;">Mirka Tech</h1>
                </div>
              </router-link>
            </div>
          </div>
          <div class="computer-nav-ul-container">
            <ul>
              <li>
                <router-link
                  to=""
                  v-scroll-to="{
                    el: '#footer',
                    duration: 2000,
                    easing: 'ease-in'
                  }"
                  :style="$i18n.locale === 'en' ? 'letter-spacing: 2px;' : ''"
                >
                  {{ $t("contact") }}
                </router-link>
              </li>
              <li>
                <router-link
                  to="/"
                  :style="$i18n.locale === 'en' ? 'letter-spacing: 2px;' : ''"
                  v-scroll-to="{
                    el: '#services',
                    duration: 500,
                    easing: 'ease-in'
                  }"
                >
                  {{ $t("services") }}
                </router-link>
              </li>
              <li>
                <router-link
                  to="/"
                  :style="$i18n.locale === 'en' ? 'letter-spacing: 2px;' : ''"
                  v-scroll-to="{
                    el: '#products',
                    duration: 2000,
                    easing: 'ease-in'
                  }"
                  >{{ $t("products") }}
                </router-link>
              </li>
              <li>
                <v-menu bottom :close-on-content-click="true" :offset-y="true">
                  <!-- :open-on-hover="true" -->
                  <template v-slot:activator="{ on }">
                    <v-btn
                      style="
                        box-shadow: none; 
                        background-color: rgba(0,0,0,0); 
                        color: #cedb2d; 
                        border: 1px solid #cedb2d;
                        border-radius: 20px;
                        font-size: 16px; 
                        font-size: 12px;
                        text-transform: lowercase;
                      "
                      v-on="on"
                    >
                      {{ lang }}
                    </v-btn>
                  </template>
                  <v-list style="background-color: #cedb2d; margin-top: 10px;">
                    <v-list-item
                      v-for="(item, i) in items"
                      :key="i"
                      @click="changeLang(item)"
                      :style="
                        i === items.length - 1
                          ? 'font-family: englishfont;'
                          : 'font-family: kurdishfont;'
                      "
                    >
                      <v-list-item-title style="font-size: 14px;">
                        {{ item.title }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <ul class="menu">
            <li class="menu-item" @click="handleOpenMenu">
              <router-link
                to=""
                v-scroll-to="{
                  el: '#footer',
                  duration: 2000,
                  easing: 'ease-in'
                }"
              >
                {{ $t("contact") }}
              </router-link>
            </li>
            <li class="menu-item" @click="handleOpenMenu">
              <router-link
                to="/"
                v-scroll-to="{
                  el: '#services',
                  duration: 2000,
                  easing: 'ease-in'
                }"
              >
                {{ $t("services") }}</router-link
              >
            </li>
            <li class="menu-item" @click="handleOpenMenu">
              <router-link
                to="/"
                v-scroll-to="{
                  el: '#products',
                  duration: 2000,
                  easing: 'ease-in'
                }"
              >
                {{ $t("products") }}</router-link
              >
            </li>
            <li class="menu-item">
              <ul class="lang-container">
                <li
                  v-for="(item, i) in items"
                  :key="i"
                  @click="changeLang(item)"
                  :style="
                    i === items.length - 1
                      ? 'font-family: englishfont;'
                      : 'font-family: kurdishfont;'
                  "
                >
                  <button>
                    {{ item.title }}
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "NavigationBar",
  computed: mapGetters(["langs"]),
  data: () => ({
    lang: "english",
    items: [
      { title: "کوردی", value: "ku" },
      { title: "عربی", value: "ar" },
      { title: "english", value: "en" }
    ]
  }),
  methods: {
    getImage(name) {
      return require("../assets/" + name);
    },
    handleOpenMenu() {
      document.querySelector(".header").classList.toggle("menu-opened");
    },
    changeLang(item) {
      this.$i18n.locale = item.value;
      this.lang = item.title;
      if (window.innerWidth <= 625) this.handleOpenMenu();
    }
  }
};
</script>

<style lang="scss" scoped>
.window .header {
  position: absolute;
  display: block;
  top: 0;
  left: 0;
  height: 15vh;
  width: 100%;
  margin: auto;
  // background: rgba(0, 0, 0, 0.8);
  overflow: hidden;
  transition: all 0.5s ease-out, background 1s ease-out;
  transition-delay: 0.2s;
  z-index: 100;
  color: #fefde5;
}
.header .burger-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 50px 50px 0px 50px;
  height: 10vh;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.computer-nav-ul-container ul {
  position: relative;
  // background-color: rebeccapurple;
  list-style-type: none;
  display: flex;
  align-items: center;
}
.computer-nav-ul-container ul li {
  margin: 0px 10px;
}
.computer-nav-ul-container ul li a {
  display: block;
  color: #cedb2d;
  font-size: 16px;
  font-weight: bolder;
}

.header .burger-container #header-title {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  // padding: 0px 20px 0px 50px;
}
.header .burger-container #header-title div img {
  width: 65px;
  margin-top: 0px;
}

.burger-wrapper {
  display: none;
}
.header .burger-container #burger {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 10vh;
  position: relative;
  cursor: pointer;
}
.header .burger-container #burger .bar {
  width: 40px;
  height: 3px;
  display: block;
  position: relative;
  background: #fefde5;
  transition: all 0.3s cubic-bezier(0.4, 0.01, 0.165, 0.99);
  transition-delay: 0s;
}
.header .burger-container #burger .bar.topBar {
  transform: translateY(0px) rotate(0deg);
}
.header .burger-container #burger .bar.btmBar {
  transform: translateY(6px) rotate(0deg);
}

.header ul.menu {
  position: relative;
  display: block;
  pointer-events: none;
  padding: 0px 7.5%;
  list-style: none;
}
.header ul.menu li.menu-item {
  border-bottom: 1px solid #333;
  margin-top: 30px;
  transform: scale(1.15) translateY(-30px);
  opacity: 0;
  transition: transform 0.5s cubic-bezier(0.4, 0.01, 0.165, 0.99),
    opacity 0.6s cubic-bezier(0.4, 0.01, 0.165, 0.99);
}
.header ul.menu li.menu-item:nth-child(1) {
  transition-delay: 0.49s;
}
.header ul.menu li.menu-item:nth-child(2) {
  transition-delay: 0.42s;
}
.header ul.menu li.menu-item:nth-child(3) {
  transition-delay: 0.35s;
}
.header ul.menu li.menu-item:nth-child(4) {
  transition-delay: 0.28s;
}
.header ul.menu li.menu-item:nth-child(5) {
  transition-delay: 0.21s;
}
.header ul.menu li.menu-item:nth-child(6) {
  transition-delay: 0.14s;
}
.header ul.menu li.menu-item:nth-child(7) {
  transition-delay: 0.07s;
}
.header ul.menu li.menu-item a {
  display: block;
  position: relative;
  color: #fefde5;
  font-weight: 100;
  text-decoration: none;
  font-size: 16px;
  line-height: 2.35;
  font-weight: 200;
  width: 100%;
}

.header.menu-opened {
  height: 100%;
  background-color: #000;
  transition: all 0.3s ease-in, background 0.5s ease-in;
  transition-delay: 0.25s;
}
.header.menu-opened .header ul.menu {
  visibility: visible;
}
.header.menu-opened .burger-container #burger .bar {
  transition: all 0.4s cubic-bezier(0.4, 0.01, 0.165, 0.99);
  transition-delay: 0.2s;
}
.header.menu-opened .burger-container #burger .bar.topBar {
  transform: translateY(4px) rotate(45deg);
}
.header.menu-opened .burger-container #burger .bar.btmBar {
  transform: translateY(2px) rotate(-45deg);
}
.header.menu-opened ul.menu li.menu-item {
  transform: scale(1) translateY(0px);
  opacity: 1;
}
.header.menu-opened ul.menu li.menu-item:nth-child(1) {
  transition-delay: 0.27s;
}
.header.menu-opened ul.menu li.menu-item:nth-child(2) {
  transition-delay: 0.34s;
}
.header.menu-opened ul.menu li.menu-item:nth-child(3) {
  transition-delay: 0.41s;
}
.header.menu-opened ul.menu li.menu-item:nth-child(4) {
  transition-delay: 0.48s;
}
.header.menu-opened ul.menu li.menu-item:nth-child(5) {
  transition-delay: 0.55s;
}
.header.menu-opened ul.menu li.menu-item:nth-child(6) {
  transition-delay: 0.62s;
}
.header.menu-opened ul.menu li.menu-item:nth-child(7) {
  transition-delay: 0.69s;
}

// lang container
.lang-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
  padding-bottom: 20px;
}
.lang-container li:nth-child(2) {
  margin: 0px 25px;
}
.lang-container button {
  background-color: rgba(255, 0, 0, 0);
  color: #fefde5;
  font-weight: 100;
  font-size: 16px;
  line-height: 2.35;
  font-weight: 200;
  padding: 6px 12px;
  border: 1px solid #cedb2d;
  border-radius: 5px;
  cursor: pointer;
}
.lang-container li:hover {
  color: #000;
}

@media (max-width: 768px) {
  .computer-nav-ul-container {
    display: none;
  }
  .header .burger-container {
    padding: 0px 50px 0px 20px;
  }
  .header ul.menu {
    pointer-events: visible;
  }
  .burger-wrapper {
    display: block;
  }
  .header .burger-container #header-title {
    padding: 0px 40px;
  }
  .header .burger-container #header-title div img {
    width: 55px;
    margin-top: 5px;
  }
}
@media (max-width: 625px) {
  .header .burger-container #header-title h1 {
    font-size: 20px;
    padding-top: 6px;
  }
}

@media (max-width: 375px) {
  #header-title {
    width: 300px;
  }
}
</style>
